import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NGUOIPHOIHOP } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { NGUOIPHOIHOP_API } from '../../utils/apiUrl.js';

// ------------------------------
// GET ALL
// ------------------------------
export const nguoiPhoiHopGetAllAction = createAsyncThunk(
    NGUOIPHOIHOP.GET_ALL,
    async (_, { rejectWithValue }) => {
        try {
            const response = await Get(NGUOIPHOIHOP_API.GET_ALL);
            return response || [];
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// GET PAGING
// ------------------------------
export const nguoiPhoiHopPagingAction = createAsyncThunk(
    NGUOIPHOIHOP.GET_ALL_PAGING,
    async (model = {}, { rejectWithValue }) => {
        try {
            const pageIndex = model?.PageIndex ?? model?.pageIndex ?? 1;
            const pageSize = model?.PageSize ?? model?.pageSize ?? 20;
            const keyword = model?.Keyword ?? model?.keyword ?? '';

            const params = new URLSearchParams({
                Keyword: keyword,
                PageIndex: pageIndex,
                PageSize: pageSize
            });

            const url = `${NGUOIPHOIHOP_API.GET_ALL_PAGING}?${params.toString()}`;
            const response = await Get(url);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// GET ITEM
// ------------------------------
export const nguoiPhoiHopGetItemAction = createAsyncThunk(
    NGUOIPHOIHOP.GET_BY_ID,
    async (id, { rejectWithValue }) => {
        try {
            const response = await Get(NGUOIPHOIHOP_API.GET_BY_ID(id));
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// ADD / EDIT / DELETE
// ------------------------------
export const addNguoiPhoiHopAction = createAsyncThunk(
    NGUOIPHOIHOP.CREATE,
    async (model, { rejectWithValue }) => {
        try {
            const res = await Post(NGUOIPHOIHOP_API.CREATE, null, model, false);
            return res.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const editNguoiPhoiHopAction = createAsyncThunk(
    NGUOIPHOIHOP.UPDATE,
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await Put(NGUOIPHOIHOP_API.UPDATE(id), null, data);
            return res.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const deleteNguoiPhoiHopAction = createAsyncThunk(
    NGUOIPHOIHOP.DELETE,
    async (id, { rejectWithValue, fulfillWithValue }) => {
        try {
            const res = await DeleteSingle(NGUOIPHOIHOP_API.DELETE(id));
            if (res && typeof res.status === 'number' && res.status === 200) return fulfillWithValue(res.status);
            let errJson = null;
            try {
                errJson = await res.json();
            } catch (e) {}
            return rejectWithValue(errJson || res);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// ------------------------------
// INITIAL STATE
// ------------------------------
const initialState = {
    listNguoiPhoiHop: [],
    totalNguoiPhoiHop: 0,
    nguoiPhoiHopItem: null
};

// ------------------------------
// SLICE
// ------------------------------
export const nguoiPhoiHopSlice = createSlice({
    name: NGUOIPHOIHOP.NAME_SLICE,
    initialState,
    reducers: {
        filterListNguoiPhoiHop: (state, action) => {
            state.listNguoiPhoiHop = state.listNguoiPhoiHop.filter(x => x.id !== action.payload);
            state.totalNguoiPhoiHop -= 1;
        }
    },
    extraReducers: (builder) => {
        builder
            // GET ALL
            .addCase(nguoiPhoiHopGetAllAction.fulfilled, (state, action) => {
                state.listNguoiPhoiHop = action.payload || [];
            })
            .addCase(nguoiPhoiHopGetAllAction.rejected, (state) => {
                state.listNguoiPhoiHop = [];
            })

            // PAGING
            .addCase(nguoiPhoiHopPagingAction.fulfilled, (state, action) => {
                state.listNguoiPhoiHop = action.payload?.data || [];
                state.totalNguoiPhoiHop = action.payload?.totalRecords || 0;
            })
            .addCase(nguoiPhoiHopPagingAction.rejected, (state) => {
                state.listNguoiPhoiHop = [];
                state.totalNguoiPhoiHop = 0;
            })

            // GET ITEM
            .addCase(nguoiPhoiHopGetItemAction.fulfilled, (state, action) => {
                state.nguoiPhoiHopItem = action.payload;
            })
            .addCase(nguoiPhoiHopGetItemAction.rejected, (state) => {
                state.nguoiPhoiHopItem = null;
            });
    }
});

export const { filterListNguoiPhoiHop } = nguoiPhoiHopSlice.actions;
export default nguoiPhoiHopSlice.reducer;
    